<template>
  <v-form
  @submit.prevent="onSubmitForm"
  ref="purchaserForm"
  >
  <div class="purchaser-wrapper">
    <div class="purchaser-dialog-block">
      <div class="purchaser-dialog-block__help-text">
        Выберите покупателя из списка гостей
      </div>

      <div class="purchaser-dialog-block__input-block purchaser-input-block">
        <ui-field label="Гость">
          <v-select
            class="ui-select"
            label="Выберите гостя"
            solo single-line
            :menu-props="{ offsetY: true }"
            item-text="fullName"
            item-value="id"
            v-model="purchaser.guestId"
            :disabled="isPurchaserNotGuest"
            :items="guestListForPurchaser"
            :rules="isPurchaserNotGuest ? [] : [validationRules.required]">
            <template v-slot:prepend-inner>
              <v-icon>$user</v-icon>
            </template>
          </v-select>
        </ui-field>
      </div>

      <div class="purchaser-dialog-block__checkbox-purchaser">
        <v-checkbox
          class="ui-checkbox"
          label="Я покупатель, не являющийся гостем"
          :readonly="isPresent"
          v-model="isPurchaserNotGuest">
        </v-checkbox>
      </div>

      <div
        class="purchaser-dialog-block__purchaser-data purchaser-data-block"
        v-if="isPurchaserNotGuest">
        <div class="purchaser-data-block__help-text">
          Заполните свои данные
        </div>
        <ui-field label="Фамилия">
          <v-text-field
            solo
            class="ui-input"
            label="Введите Фамилию"
            v-model="purchaser.secondName"
            prepend-inner-icon="$user"
            :rules="isPurchaserNotGuest ? [validationRules.required] : []"
          />
        </ui-field>

        <ui-field label="Имя">
          <v-text-field
            solo
            class="ui-input"
            label="Введите Имя"
            v-model="purchaser.firstName"
            prepend-inner-icon="$user"
            :rules="isPurchaserNotGuest ? [validationRules.required] : []"
          />
        </ui-field>

        <ui-field label="Отчество">
          <template v-slot:headerAppend>
            <a href="javascript:void(0)"
               class="guest-form_no-third-name-link"
                @click="changeHaveNoThirdName">
              {{ guestHaveNoThirdName ? "С отчеством" : "Без отчества" }}
            </a>
          </template>
          <v-text-field
            solo
            class="ui-input"
            label="Введите отчество"
            v-model="purchaser.thirdName"
            :rules="isPurchaserNotGuest && !guestHaveNoThirdName ? [validationRules.required] : []"
            :required="!guestHaveNoThirdName"
            :disabled="guestHaveNoThirdName">
            <template v-slot:prepend-inner>
              <v-icon>$user</v-icon>
            </template>
          </v-text-field>
        </ui-field>

        <ui-field :label="'Дата рождения'">
          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            nudge-top="-46px"
            v-model="birthdayMenu"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                label="Дата рождения"
                v-on="on"
                solo
                class="ui-input"
                v-mask="'##.##.####'"
                v-model="birthday"
                :rules="isPurchaserNotGuest ? [validationRules.required, birthdayRules] : []"
              >
                <template v-slot:prepend-inner>
                  <v-icon>$calendar</v-icon>
                </template>
              </v-text-field>
            </template>
            <v-date-picker
              locale="ru-ru" width="auto"
              class="ui-datepicker"
              no-title v-model="birthdayPicker"
              @change="onChangeBirthdayDatepicker"
              :min="minDatePickerBirthDate"
              :max="maxDatePickerBirthDate"
              first-day-of-week="1"
              :weekday-format="helpers.getWeekDay"
            />
          </v-menu>
        </ui-field>

        <ui-field :label="'Телефон'">
          <v-text-field
            solo
            autocomplete="off"
            class="ui-input"
            label="Введите номер телефона"
            v-mask="'+7 (###) ###-##-##'"
            v-model="purchaser.phone"
            @input="onInput"
            :rules="[validationRules.tel, existPhoneRules()]">
            <template v-slot:prepend-inner>
              <v-icon>$phone</v-icon>
            </template>
          </v-text-field>
        </ui-field>

        <ui-field :label="'Почта'">
          <v-text-field
            solo
            class="ui-input"
            label="Введите email"
            v-model="purchaser.email"
            :rules="isPurchaserNotGuest ? [validationRules.required, validationRules.email, existEmailRules()] : []">
            <template v-slot:prepend-inner>
              <v-icon>$mailSolid</v-icon>
            </template>
          </v-text-field>
        </ui-field>
      </div>
    </div>
  </div>
  </v-form>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import Helpers from '@/helpers/Helpers'
import UiField from "@/components/UI/UiField.vue";

const MAXIMUM_YEAR_PURCHASER = 110;
const MINIMUM_YEAR_PURCHASER = 14;

export default {
  name: 'PurchaserForm',
  components: {UiField},

  props: {
    purchaser: {
      type: Object,
    },
  },

  data() {
    return {
      guestHaveNoThirdName: false,
      purchaserNotGuest: false,
      birthday: "",
      birthdayPicker: "",

      birthdayMenu: false,

      validationRules: {
        required: value => !!value || "Обязательно к заполнению",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || "Неверный формат email"
        },
        tel: value => {
          const pattern = /^\+7\s{1}\(\d{3}\)\s{1}\d{3}\-\d{2}\-\d{2}$/
          return pattern.test(value) || "Неверный формат номера телефона"
        },
      },
      existEmailRules: function () {
        return (value) => {
          const storedEmails = this.getGuestsList.map(guest => guest.email) ?? [],
            includeEmailCount = storedEmails.filter(email => email === value).length;

          return !includeEmailCount || 'Уже указан гость с таким email.';
        };
      },
      existPhoneRules: function () {
        return (value) => {
          const storedPhones = this.getGuestsList.map(guest => guest.phone) ?? [],
            includePhoneCount = storedPhones.filter(phone => phone === value).length;

          return !includePhoneCount || 'Уже указан гость с таким номером телефона.';
        };
      },
    };
  },

  mounted() {
    this.setDefaultPurchaser();
  },

  computed: {
    ...mapState({
      isPresent: state => state.selection.isPresent,
    }),
    ...mapGetters({
      getGuestsList: 'guestsModule/getGuestsList',
    }),

    helpers() {
      return Helpers
    },

    isPurchaserNotGuest: {
      immediate: true,
      get() {
        return this.isPresent || this.purchaserNotGuest;
      },
      set(value) {
        this.purchaserNotGuest = this.isPresent || value;
      },
    },

    /**
     * Return only adult guests
     * @returns {*}
     */
    guestListForPurchaser() {
      // guestType=0 - adult
      const filteredGuestList = this.getGuestsList.filter((guest) => guest.guestType === '0') ?? [];
      filteredGuestList.forEach(guest => {
        guest.fullName = `${guest.secondName} ${guest.firstName} ${guest.thirdName ?? ""}`;
      });

      return filteredGuestList;
    },

    /**
     * Date birth min and max dates
     * @returns {string}
     */
    minDatePickerBirthDate() {
      let today = new Date();
      return new Date(
        today.getFullYear() - MAXIMUM_YEAR_PURCHASER,
        today.getMonth(),
        today.getDate()
      ).toISOString()
    },
    maxDatePickerBirthDate() {
      let today = new Date();
      return new Date(
        today.getFullYear() - MINIMUM_YEAR_PURCHASER,
        today.getMonth(),
        today.getDate() + 1
      ).toISOString();
    },

    birthdayRules() {
      return (value) => {
        let splited = value ? value.split(".") : []
        let res = true

        // правила для дня
        if(splited[0]
          && splited[0].length
          && (+splited[0] < 1 || +splited[0] > 31)
        ) {
          res = "Введено некорректное значение"
        }

        // правила для месяца
        if(splited[1]
          && splited[1].length
          && (
            +splited[1] < 1
            || +splited[1] > 12
            || ( [1,3,5,7,8,10,12].findIndex(i => i === +splited[1]) !== -1 && +splited[0] > 31 )
            || ( [4,6,9,11].findIndex(i => i === +splited[1]) !== -1 && +splited[0] > 30 )
            || ( +splited[1] === 2 && +splited[0] > 29 )
          )
        ) {
          res = "Введено некорректное значение"
        }

        // правила для года
        if(splited[2] && splited[2].length < 4) {
          res = "Введено некорректное значение"
        }
        else {
          let now = new Date(),
            currentYear = new Date(+splited[2], +splited[1] - 1, +splited[0]),
            minYear = new Date(now.getFullYear() - MAXIMUM_YEAR_PURCHASER, now.getMonth(), now.getDate()),
            childYear = new Date(now.getFullYear() - 14, now.getMonth(), now.getDate())
            if (currentYear > childYear || currentYear <= minYear) {
              res = "Введенное значение не соответствует типу гостя"
            }
        }

        return res
      }
    },
  },

  methods: {
    setDefaultPurchaser() {
      const defaultPurchaser = {
        secondName: "",
        firstName: "",
        thirdName: "",
        birthday: "",
        phone: "",
        email: "",
        guestId: null,
        isNotGuest: false,
      };
      for (const purchaserKey of Object.keys(defaultPurchaser)) {
        let value = defaultPurchaser[purchaserKey];
        this.$set(this.purchaser, purchaserKey, value);
      }
    },

    changeHaveNoThirdName() {
      this.guestHaveNoThirdName = !this.guestHaveNoThirdName;
      if (this.guestHaveNoThirdName) this.purchaser.thirdName = null;
    },

    mutatePurchaserBeforeSubmit() {
      this.purchaser.isNotGuest = this.isPurchaserNotGuest;
    },

    /**
     * мутация списка гостей (гость покупатель - становится покупателем, а все остальные гости - не становятся)
     */
    mutateGuestListBeforeSubmit() {
      this.getGuestsList.forEach(guest => {
        guest.isPurchaser = false;

        if (this.purchaser.guestId === guest.id && !this.purchaserNotGuest) {
          guest.isPurchaser = true;
        }
      });
    },

    /**
     * Event handlers
     */
    onClickNoThirdName(event) {
      let haveThirdName = this.guestHaveNoThirdName;
      event.target.innerHTML = haveThirdName ? "Без отчества" : "С отчеством"
    },

    onSubmitForm(event) {
      let isValid = this.$refs.purchaserForm.validate();
      if (!isValid) return;
      this.mutatePurchaserBeforeSubmit();
      this.mutateGuestListBeforeSubmit();

      // form is valid
      this.$emit("validSubmit");
    },

    onChangeBirthdayDatepicker(value) {
      let a = value.split(`-`);
      this.birthday = `${a[2]}.${a[1]}.${a[0]}`;
      this.birthdayMenu = false;

      this.purchaser.birthday = value;
    },

    onInput(e) {
      this.$emit("input", e.target?.value);
    },

    /**
     * Public methods
     */
    submitForm() {
      this.$refs.purchaserForm.$el.requestSubmit();
    },
  },

  watch: {
    birthday(v) {
      this.$set(this.purchaser, `birthday`, Helpers.dateLocaleToIso(v));
    }
  }
};
</script>

<style>

.purchaser-dialog-block__help-text {
  margin-bottom: 20px;
}

.purchaser-data-block__help-text {
  margin-bottom: 20px;
}

.purchaser-data-block {
  padding: 1.25em;
  background: #ECFAFB;
  border-radius: 1.25em;
}
</style>
